import styled from '@emotion/styled';
import { Typography } from '../../atoms/typography/Typography';

export const TooltipTrigger = styled.div<{ $fitContent?: boolean }>`
  position: relative;
  display: inline-flex;
  width: ${({ $fitContent }) => ($fitContent ? 'auto' : '100%')};
`;

export const TooltipMotionWrapper = styled.div`
  position: fixed;
  z-index: 10000;
`;

export const TooltipContent = styled(Typography)`
  background-color: ${({ theme }) => theme.colors.technical['adaptive-reverse']};
  color: ${({ theme }) => theme.colors.technical.adaptive};
  padding: 4px 8px;
  font-weight: 600;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

/** Figma “footnote” tooltip: white card, small type, multi-line friendly */
export const TooltipContentCompact = styled.span<{ $maxWidth?: number | string }>`
  display: block;
  box-sizing: border-box;
  max-width: ${({ $maxWidth }) =>
    $maxWidth != null ? (typeof $maxWidth === 'number' ? `${$maxWidth}px` : $maxWidth) : '240px'};
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.technical.white};
  color: ${({ theme }) => theme.colors.technical.black};
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.16);
`;
